import apiClient from './apiClient';
import { DashboardStats } from '../types/dashboard';

const apiBaseURL = '/dashboard';

class DashboardService {
    /**
     * Get comprehensive dashboard statistics
     */
    async getDashboardStats(): Promise<DashboardStats> {
        const response = await apiClient.get<DashboardStats>(`${apiBaseURL}/stats`);
        return response.data;
    }
}

export const dashboardService = new DashboardService();
export default dashboardService;
